import React, { useCallback, useState } from 'react';
import {
    CheckboxInput,
    SearchInput,
} from '@instinet-analytics/semantic-ui-components';
import { useOnEnter } from '@instinet-analytics/core-lib';
import { useAddWidgetData } from 'appToolbar/AddWidgetModal/useAddWidgetData';
import { AvailableWidgetsAccordian } from 'appToolbar/AddWidgetModal/AvailableWidgetsAccordian';
import { WidgetPreview } from 'appToolbar/AddWidgetModal/WidgetPreview';
import { AddWidgetSelectedItem } from 'appToolbar/AddWidgetModal/AddWidgetModal';
import ManagedLayout from 'layoutManagement/ManagedLayout';
import { WidgetType } from 'widgets/WidgetType';
import { useSupportVisualisationPopupParent } from 'widgets/supportVisualisation/SupportVisualisationPopup/SupportVisualisationPopupService';
import { useDispatchRequestAddWidget } from '../../layoutRenderer/store/dispatcher';

export interface AddWidgetModalBodyProps {
    addMultiple: boolean;
    previewItem?: AddWidgetSelectedItem;
    selectedItems: AddWidgetSelectedItem[];
    onClickAddItem: (wt: WidgetType) => void;
    onToggleAddMultiple: () => void;
    onClickItem: (wt: AddWidgetSelectedItem) => void;
    onChangeLayout: (wt: AddWidgetSelectedItem) => void;
    onClickEnter: () => void;
}
export function AddWidgetModalBody(props: AddWidgetModalBodyProps) {
    const {
        addMultiple,
        selectedItems,
        previewItem,
        onClickAddItem,
        onClickItem,
        onChangeLayout,
        onToggleAddMultiple,
        onClickEnter,
    } = props;
    const [searchText, setSearchText] = useState('');
    const data = useAddWidgetData();
    const popupParent = useSupportVisualisationPopupParent();
    const dispatchRequestAddWidget = useDispatchRequestAddWidget();

    const onInputChange = (text: string) => {
        if (text === 's-sv') {
            popupParent!.openPopup();
            setSearchText('');
            return;
        }
        if (text === 'a-sv') {
            dispatchRequestAddWidget([
                { widget: WidgetType.SUPPORT_VISUALISATION },
            ]);
            setSearchText('');
            return;
        }
        setSearchText(text);
    };

    const onSelectedLayoutChanged = (layout?: ManagedLayout) =>
        onChangeLayout({ widget: previewItem!.widget, layout });

    const onEnter = useCallback(() => {
        if (selectedItems.length > 0) {
            onClickEnter();
        }
    }, [onClickEnter, selectedItems]);

    useOnEnter(onEnter);

    return (
        <div className="AddWidgetModalBody">
            <section className="AvailableWidgets">
                <header>
                    <div className="title">Available Widgets</div>
                    <div className="search">
                        <SearchInput
                            value={searchText}
                            onChange={onInputChange}
                            placeholder="Search"
                        />
                    </div>
                </header>

                <AvailableWidgetsAccordian
                    data={data}
                    searchText={searchText}
                    previewItem={previewItem}
                    selectedItems={selectedItems}
                    addMultiple={addMultiple}
                    onClickItem={onClickItem}
                    onClickAddItem={onClickAddItem}
                />
                <CheckboxInput
                    className="add-multiple"
                    label="Add Multiple"
                    checked={addMultiple}
                    onToggle={onToggleAddMultiple}
                />
            </section>
            <section className="WidgetPreviewContainer">
                <WidgetPreview
                    addMultiple={addMultiple}
                    previewItem={previewItem}
                    onSelectedLayoutChanged={onSelectedLayoutChanged}
                />
            </section>
        </div>
    );
}
